import React from 'react';
import { Helmet } from 'react-helmet';
import { Route, Routes } from 'react-router-dom';

import { useAlertCenterAccess } from 'App/utils/hooks/useIsPermitted';
import env from '../config/config';
import { NotFound } from '../errors';
import Main from '../styles/Main/Main';
import PageTitle from '../styles/PageTitle/PageTitle';
import PageWrapper from '../styles/PageWrapper/PageWrapper';
import FinancialAssistance from './FinancialAssistance';
import AvailablePatients from './FinancialAssistance/AvailablePatients';

const propTypes = {};

const defaultProps = {};

function AlertsCenterPage() {
    const hasAlertCenterAccess = useAlertCenterAccess();

    if (hasAlertCenterAccess) {
        return (
            <Main>
                <Helmet>
                    <title>Alerts Center - {env.catchPhrase}</title>
                </Helmet>

                <PageTitle>Alerts Center</PageTitle>
                <PageWrapper>
                    <Routes>
                        <Route path="/financial-assistance/:programId/patients" element={<AvailablePatients />} />

                        <Route index element={<FinancialAssistance />} />
                    </Routes>
                </PageWrapper>
            </Main>
        );
    }

    return <NotFound />;
}

AlertsCenterPage.propTypes = propTypes;
AlertsCenterPage.defaultProps = defaultProps;

export default AlertsCenterPage;
